/**
 * IA answers: Markdown-like text stored in DB. Escape HTML first, then a small safe subset.
 * User messages: escapeUserChatHtml only.
 */
function escapeHtml(text) {
	return String(text)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

export function escapeUserChatHtml(text) {
	if (text == null || text === '') return '';
	return escapeHtml(String(text)).replace(/\r\n/g, '\n').replace(/\r/g, '\n').replace(/\n/g, '<br>');
}

export function formatIaAnswerHtml(text) {
	if (text == null || text === '') return '';
	let s = escapeHtml(String(text).replace(/\r\n/g, '\n').replace(/\r/g, '\n'));

	s = s.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
	s = s.replace(/__([^_]+)__/g, '<u>$1</u>');
	s = s.replace(/(^|\s)\*([^*\n]+)\*(?=\s|$)/g, '$1<em>$2</em>');

	s = s.replace(/\n\n+/g, '</p><p class="chat-ia-p">');
	s = s.replace(/\n/g, '<br>');
	return '<p class="chat-ia-p">' + s + '</p>';
}
